// Voice-Player: spielt pro Stimme eine MP3-Aufnahme (data-audio) oder einen
// synthetischen Fallback-Ton (data-freq), solange keine Aufnahme hochgeladen ist.
export default function initVoices() {
    const container = document.querySelector('.js-voices');
    if (!container) return;

    const buttons = Array.from(container.querySelectorAll('.js-voice'));
    const allButton = container.querySelector('.js-voice-all');
    if (!buttons.length) return;

    const audioEls = {};
    const playing = {};
    let ctx = null;

    function toneCtx() {
        if (!ctx) {
            const AC = window.AudioContext || window.webkitAudioContext;
            ctx = new AC();
        }
        if (ctx.state === 'suspended') ctx.resume();
        return ctx;
    }

    function audioFor(btn) {
        const key = btn.dataset.key;
        if (!audioEls[key]) {
            const el = new Audio(btn.dataset.audio);
            el.loop = true;
            el.preload = 'auto';
            audioEls[key] = el;
        }
        return audioEls[key];
    }

    function startTone(freq, rec) {
        const c = toneCtx();
        const gain = c.createGain();
        gain.gain.setValueAtTime(0.0001, c.currentTime);
        gain.gain.exponentialRampToValueAtTime(0.10, c.currentTime + 0.25);
        const osc = c.createOscillator();
        osc.type = 'sine';
        osc.frequency.value = freq;
        const harm = c.createOscillator();
        harm.type = 'triangle';
        harm.frequency.value = freq * 2;
        const hg = c.createGain();
        hg.gain.value = 0.045;
        const vib = c.createOscillator();
        vib.frequency.value = 5.2;
        const vibG = c.createGain();
        vibG.gain.value = freq * 0.006;
        vib.connect(vibG);
        vibG.connect(osc.frequency);
        vibG.connect(harm.frequency);
        osc.connect(gain);
        harm.connect(hg);
        hg.connect(gain);
        gain.connect(c.destination);
        osc.start();
        harm.start();
        vib.start();
        rec.tone = { osc, harm, vib, gain };
    }

    // currentTime einer bereits laufenden Aufnahme, damit neue Stimmen synchron einsteigen
    function syncPoint() {
        for (const k in playing) {
            const o = playing[k];
            if (o.el && !o.el.paused) return o.el.currentTime;
        }
        return 0;
    }

    function start(btn) {
        const key = btn.dataset.key;
        if (playing[key]) return;
        const rec = {};
        playing[key] = rec;
        if (btn.dataset.audio) {
            const el = audioFor(btn);
            const t = syncPoint();
            const p = el.play();
            if (p && p.then) {
                p.then(() => {
                    rec.el = el;
                    try { el.currentTime = t; } catch (e) { /* noop */ }
                }).catch(() => startTone(parseFloat(btn.dataset.freq), rec));
            } else {
                rec.el = el;
            }
        } else {
            startTone(parseFloat(btn.dataset.freq), rec);
        }
    }

    function stopOne(key) {
        const rec = playing[key];
        if (!rec) return;
        if (rec.el) rec.el.pause();
        if (rec.tone) {
            const t = ctx.currentTime;
            rec.tone.gain.gain.cancelScheduledValues(t);
            rec.tone.gain.gain.setValueAtTime(Math.max(rec.tone.gain.gain.value, 0.0001), t);
            rec.tone.gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.3);
            [rec.tone.osc, rec.tone.harm, rec.tone.vib].forEach((o) => o.stop(t + 0.35));
        }
        delete playing[key];
    }

    function silence() {
        Object.keys(playing).forEach(stopOne);
        render();
    }

    function playAll() {
        buttons.forEach((btn) => {
            if (!playing[btn.dataset.key]) start(btn);
        });
        // alle Aufnahmen auf einen gemeinsamen Startpunkt schieben
        setTimeout(() => {
            Object.keys(playing).forEach((k) => {
                const o = playing[k];
                if (o.el) {
                    try { o.el.currentTime = 0; } catch (e) { /* noop */ }
                }
            });
        }, 70);
        render();
    }

    function render() {
        let anyOn = false;
        let allOn = true;
        buttons.forEach((btn) => {
            const on = !!playing[btn.dataset.key];
            btn.classList.toggle('is-playing', on);
            anyOn = anyOn || on;
            allOn = allOn && on;
        });
        if (allButton) {
            allButton.classList.toggle('is-playing', allOn);
            allButton.classList.toggle('is-some', anyOn && !allOn);
        }
    }

    buttons.forEach((btn) => {
        btn.addEventListener('click', () => {
            const key = btn.dataset.key;
            if (playing[key]) stopOne(key);
            else start(btn);
            render();
        });
    });

    if (allButton) {
        allButton.addEventListener('click', () => {
            const allOn = buttons.every((btn) => playing[btn.dataset.key]);
            if (allOn) silence();
            else playAll();
        });
    }

    window.addEventListener('pagehide', silence);
}
